"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelWithNoneEnum = void 0;
var ChannelWithNoneEnum;
(function (ChannelWithNoneEnum) {
    ChannelWithNoneEnum["None"] = "-";
    ChannelWithNoneEnum["Voice"] = "V";
    ChannelWithNoneEnum["Chat"] = "C";
    ChannelWithNoneEnum["Mail"] = "M";
    ChannelWithNoneEnum["Form"] = "F";
    ChannelWithNoneEnum["Sms"] = "S";
    ChannelWithNoneEnum["InternalNote"] = "In";
})(ChannelWithNoneEnum = exports.ChannelWithNoneEnum || (exports.ChannelWithNoneEnum = {}));
